<asw-plan-review-pres [fareConditionsResponse]="fareConditionsResponse"></asw-plan-review-pres>
